export default function Fork() {
  return (
    <div
      className="ion-icon-fork"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M270.2,148.9C270.2,149,270.1,149,270.2,148.9v0.1V148.9z"/>
	<path d="M320,166c0-43.2-15-93.2-24-133.7V32h-8l-0.2,116.9c0,6.1-2.9,11.1-9,11.1c-5.7,0-8-4.3-8.6-9.9c-0.1-0.4,0-0.8,0-1.2
		L259.9,32h-8l-9,117l-0.1,1.1c-0.6,5.6-3.7,9.9-9.5,9.9c-6.1,0-9.1-5-9.1-11.1L223.8,32h-8C207,73,192,122.9,192,166.1
		c0,25.7,14.6,48.1,36.7,58.2c11.2,5.1,11.3,10.3,11.3,10.3s-16,201.7-16,213.1c0,11.4,4,18.5,9.5,24s14.2,8.2,22.4,8.2
		c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c8.2,0,16.8-2.7,22.4-8.2c5.5-5.5,9.3-10.9,9.3-24c0-13.1-16-213.1-16-213.1s-1-5,11.4-10.6
		C305,214.2,320,191.8,320,166z"/>
</g>
</svg>
`,
      }}
    />
  )
}
